import api from './api';

const accountTwoFactorService = {
  get: async id => (await api.get(`/accounts/${id}/two-factor`)).data.data,
  setPassword: async (id, values) => (await api.post(`/accounts/${id}/two-factor/password`, values)).data.data,
  confirmEmail: async (id, code) => (await api.post(`/accounts/${id}/two-factor/recovery-email/confirm`, { code })).data.data,
  resendEmail: async id => (await api.post(`/accounts/${id}/two-factor/recovery-email/resend`, {})).data.data,
};

export default accountTwoFactorService;
